var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H10V5H5V10ZM12.5 25H17.5V20H12.5V25ZM5 25H10V20H5V25ZM5 17.5H10V12.5H5V17.5ZM12.5 17.5H17.5V12.5H12.5V17.5ZM20 5V10H25V5H20ZM12.5 10H17.5V5H12.5V10ZM20 17.5H25V12.5H20V17.5ZM20 25H25V20H20V25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.5a0f81cc26ebcd7c67edf652c82e18ec.svg";
export { ForwardRef as ReactComponent };